module.exports = __webpack_public_path__ + "07f4f36e0182f135c683dceae6a81779.png";